import { TmApiAccessError } from '@/core/error/transport/tmApiAccessError'

export class TmAuthSsoOnlyAvailableError extends TmApiAccessError {
  public name = 'TmAuthSsoOnlyAvailableError'
}
